/**
 * Layout: Checkout
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the checkout template.
 *
 * @namespace checkout
 */

import axios from 'axios';
import Cookies from 'js-cookie';
import '../../styles/checkout.scss';
import '../helpers/polyfill';


/**
 * Get products' tag names
 */
function getTags(handle) {
  axios.get(`/products/${handle}.js`)
    .then((response) => {
      const tags = response.data.tags;
      const productId = response.data.id;
      const productSelector = document.querySelector(`[data-product-id='${productId}']`);

      tags.forEach((tag) => {
        if (tag === 'preorder') {
          preOrderTemplate(productSelector.querySelector('.product__description'));
        }
      });

      return response;
    })
    .catch((error) => {
      return error;
    });
}

function preOrderTemplate(target) {
  const preOrderDiv = document.createElement('div');

  const html = `
    <div class="label">
      This item will be shipped when available
    </div>
  `;

  preOrderDiv.innerHTML = html;
  target.appendChild(preOrderDiv);
}

/**
 * Get products handle names
 */
function getProductsInCart() {
  axios.get('/cart.js')
    .then((response) => {
      const products = response.data.items;
      products.forEach((item) => {
        getTags(item.handle);
      });

      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

/**
 * Unselecting country if selected
 */
// if (document.querySelector('#checkout_shipping_address_country')) {
//   const select = document.querySelector('#checkout_shipping_address_country');
//   select.value = '---';
// }

(function($) {
  $(document).on("page:load page:change", function() {

    if (document.getElementById("checkout_shipping_address_country") != null) {

      // Sort Alphabetically
      function alphabetizeList(listField) {
        const sel = $(listField);
        const selected = sel.val(); // cache selected value, before reordering
        const opts_list = sel.find("option");
        opts_list.sort(function(a, b) {
          return $(a).text() > $(b).text() ? 1 : -1;
        });
        sel.html("").append(opts_list);
        sel.val(selected); // set cached selected value
      }
      alphabetizeList("#checkout_shipping_address_country");

      // Remove Duplicates
      const options = [];
      document.querySelectorAll("#checkout_shipping_address_country > option").forEach(option => {
        if (options.includes(option.value)) option.remove();
        else options.push(option.value);
      });

      // Pin countries
      const newOptions = `
        <option data-code="US" value="United States">United States</option>
        <option data-code="GB" value="United Kingdom">United Kingdom</option>
        <option data-code="FR" value="France">France</option>
        <option data-code="DE" value="Germany">Germany</option>
        <option data-code="CH" value="Switzerland">Switzerland</option>
        <option data-code="AU" value="Australia">Australia</option>
      `;
      $("#checkout_shipping_address_country").prepend(newOptions);

      // Select first iteration
      const e = document.getElementById("checkout_shipping_address_country");
      const dataCode = e.options[e.selectedIndex].getAttribute("data-code");
      e.selectedIndex = document.querySelector(`#checkout_shipping_address_country option[data-code="${dataCode}"]`).index

      // function getCookie(cname) {
      //   let name = cname + "=";
      //   let decodedCookie = decodeURIComponent(document.cookie);
      //   let ca = decodedCookie.split(";");
      //   for (let i = 0; i < ca.length; i++) {
      //     let c = ca[i];
      //     while (c.charAt(0) == " ") {
      //       c = c.substring(1);
      //     }
      //     if (c.indexOf(name) == 0) {
      //       return c.substring(name.length, c.length);
      //     }
      //   }
      //   return "";
      // }
      // const localization = getCookie("localization");
      // if (localization == 'US') {
      //   const e = document.getElementById("checkout_shipping_address_country");
      //   const dataCode = e.options[e.selectedIndex].getAttribute("data-code");
      //   e.selectedIndex = document.querySelector('#checkout_shipping_address_country option[data-code="US"]').index
      // } else {
      //   const e = document.getElementById("checkout_shipping_address_country");
      //   const dataCode = e.options[e.selectedIndex].getAttribute("data-code");
      //   e.selectedIndex = document.querySelector(`#checkout_shipping_address_country option[data-code="${dataCode}"]`).index
      // }

    }

  });
})(Checkout.$);

/**
 * Remove discount code cookie and sessionStorage, if set, on thank you page
 */
if (Shopify.Checkout.step === 'thank_you') {
  if (Cookies.get('discount_code')) {
    Cookies.remove('discount_code');
  }

  if (window.sessionStorage.getItem('currentDiscount')) {
    window.sessionStorage.removeItem('currentDiscount');
  }
}

/**
 * If on thank you page send data to FB Pixel
 */
if (Shopify.checkout) {
  let checkoutProductVariantIds = [];

  Shopify.checkout.line_items.forEach((item) => {
    checkoutProductVariantIds.push(item.variant_id);
  });

  fbq('track', 'Purchase', {
    value: Shopify.checkout.total_price,
    currency: Shopify.checkout.currency,
    content_ids: checkoutProductVariantIds,
    content_type: 'product',
  });
}

/**
 * Initialise
 */
function init() {
  getProductsInCart();
}

init();
